module.exports = __webpack_public_path__ + "static/img/Settings.72800ba3.png";